import React, { useEffect, useState } from "react";
import "./Register.scss";
import logo from "../../assets/head.svg";
import check from "../../assets/check.svg";
import Input from "../../components/input/Input";
import Button from "../../components/button/Button";
import PhoneInput from "../../components/phoneInput/PhoneInput";
import CountryPicker from "../../components/countryPicker/CountryPicker";
import TitlePicker from "../../components/titlePicker/TitlePicker";
import TcModal from "../../components/modal/tcModal/TcModal";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import {
  customerRegister,
  getPrivacyPolicy,
  verifyCustomerEmail,
  verifyCustomerPhoneNumber,
} from "../../utilities/api/CustomerService";
import { useNavigate } from "react-router-dom";
import base from "../../assets/base.svg";
import logoIC from "../../assets/logo.svg";
const Register: React.FC = () => {
  const navigate = useNavigate();
  const titles = ["Mr.", "Mrs.", "Dr.", "Prof.", "Miss"];
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [promoCheck, setPromoCheck] = useState<boolean>(false);
  const [rulesCheck, setRulesCheck] = useState<boolean>(false);
  const [title, setTitles] = useState<string>(titles[0]);
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [address1, setAddress1] = useState<string>("");
  const [address2, setAddress2] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [state, setState] = useState<string>("");
  const [country, setCountry] = useState<string>("United Kingdom");
  const [countryCode, setCountryCode] = useState<string>("GB");
  const [postal, setPostal] = useState<string>("");
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    address1: "",
    city: "",
    state: "",
    country: "",
    postal: "",
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [policyData, setPolicyData] = useState<any>(null);

  const validateEmail = (email: string): boolean => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const validateForm = async (): Promise<boolean> => {
    let valid = true;
    const newErrors = {
      firstName: "",
      lastName: "",
      phoneNumber: "",
      email: "",
      address1: "",
      city: "",
      state: "",
      country: "",
      postal: "",
    };

    const regex = /^[A-Za-z]*$/;

    // Basic validations
    if (firstName.trim() === "") {
      newErrors.firstName = "Required";
      valid = false;
    }
    if (lastName.trim() === "") {
      newErrors.lastName = "Required";
      valid = false;
    }
    if (phoneNumber.trim() === "") {
      newErrors.phoneNumber = "Required";
      valid = false;
    }
    if (email.trim() === "") {
      newErrors.email = "Required";
      valid = false;
    } else if (!validateEmail(email)) {
      newErrors.email = "Invalid email format";
      valid = false;
    }
    if (!regex.test(firstName.trim())) {
      newErrors.firstName = "Only alphabetic characters are allowed.";
      valid = false;
    }
    if (!regex.test(lastName.trim())) {
      newErrors.lastName = "Only alphabetic characters are allowed.";
      valid = false;
    }
    if (address1.trim() === "") {
      newErrors.address1 = "Required";
      valid = false;
    }
    if (city.trim() === "") {
      newErrors.city = "Required";
      valid = false;
    }
    if (state.trim() === "") {
      newErrors.state = "Required";
      valid = false;
    }
    if (postal.trim() === "") {
      newErrors.postal = "Required";
      valid = false;
    }

    // verifiying email and phone number
    if (email !== "" && phoneNumber !== "") {
      setIsLoading(true);
      try {
        const [responseEmail, responsePhone] = await Promise.all([
          verifyCustomerEmail(email),
          verifyCustomerPhoneNumber(phoneNumber),
        ]);

        if (responseEmail === "Email already exists") {
          newErrors.email = "Email already exists";
          valid = false;
        }

        if (responsePhone === "Phone number already exists") {
          newErrors.phoneNumber = "Phone number already exists";
          valid = false;
        }
      } catch (error) {
        console.error("Error verifying customer information:", error);
        valid = false;
      } finally {
        setIsLoading(false);
      }
    }
    setErrors(newErrors);

    return valid;
  };

  const handleChange = (name: any) => {
    setErrors({
      ...errors,
      [name]: "",
    });
  };
  const handleRegister = () => {
    const phoneNumberParsed = parsePhoneNumberFromString(phoneNumber);
    let data = {
      PersonalDetails: {
        Title: title,
        FirstName: firstName,
        LastName: lastName,
        Address: {
          AddressType: "",
          AddressLabel: "",
          AddressLine01: address1,
          AddressLine02: address2,
          City: city,
          Region: state,
          PostalCode: postal,
          Country: country,
          CountryCode: countryCode,
        },
      },
      ContactDetails: [
        {
          PhoneCode: `+${phoneNumberParsed?.countryCallingCode}`,
          Number: phoneNumberParsed?.nationalNumber,
          CountryCode: "",
          IsDefault: true,
          Type: "MOBILE",
        },
      ],
      EmailDetails: [
        {
          Email: email,
          IsDefault: true,
        },
      ],
      Notification: {
        Marketing: {
          Allow: promoCheck,
        },
      },
    };
    setIsLoading(true);
    customerRegister(data)
      .then((response) => {
        setTimeout(() => {
          navigate("/customer/verified", { state: { data: response } });
          setIsLoading(false);
          handleClearForm();
        }, 1000);
      })
      .catch((error) => {
        setIsLoading(false);
        handleClearForm();
      });
  };
  const handleClearForm = () => {
    setFirstName("");
    setTitles(titles[0]);
    setLastName("");
    setEmail("");
    setPhoneNumber("");
    setAddress1("");
    setAddress2("");
    setCity("");
    setCountry("United Kingdom");
    setCountryCode("GB");
    setState("");
    setPostal("");
    setPromoCheck(false);
    setRulesCheck(false);
  };
  useEffect(() => {
    getPrivacyPolicy().then((response) => {
      setPolicyData(response);
    });
  }, []);
  return (
    <div className='Register'>
      <div className='header-tab'>Customer Registration</div>
      <div className='content-register'>
        <div
          className='left-content-register'
          style={{ backgroundImage: `url(${base})` }}
        >
          <div className='left-logo-container'>
            <img alt='' src={logoIC} className='logoic-img' />
          </div>
          <div className='left-text-container'>
            The multipurpose tool you need to succeed in business
          </div>
        </div>
        <div className='right-content-register'>
          <div className='regitser-container'>
            <div className='register-header'>
              <div className='reg-header-inner'>
                <div className='logo-container'>
                  <img alt='' src={logo} className='logo-img' />
                </div>
                <div>
                  <div className='header-text'>
                    Register with Us and Enjoy Exclusive Benefits
                  </div>
                  <div className='header-sub-text'>
                    Create an account with us to access special offers,
                    personalized recommendations, and a smoother checkout
                    experience.
                    <br /> Start enjoying the perks today!
                  </div>
                </div>
              </div>
            </div>
            <div className='pd-cont'>
              <div className='pd-header'>Personal Details</div>
              <div className='pd-form-cont'>
                <div className='pd-form-grid-name'>
                  <div className='title-cont'>
                    <div className='grid-item'>
                      <TitlePicker
                        label='Title'
                        titles={titles}
                        setTitles={setTitles}
                      />
                    </div>
                  </div>

                  <div className='name-cont-form'>
                    <div className='grid-item'>
                      <Input
                        label='First Name'
                        value={firstName}
                        onChange={(value) => {
                          handleChange("firstName");
                          setFirstName(value);
                        }}
                        required
                        error={errors.firstName}
                      />
                    </div>
                    <div className='grid-item'>
                      <Input
                        label='Last Name'
                        value={lastName}
                        onChange={(value) => {
                          handleChange("lastName");
                          setLastName(value);
                        }}
                        required
                        error={errors.lastName}
                      />
                    </div>
                  </div>
                </div>
                <div className='pd-form-grid-2'>
                  <div className='grid-item'>
                    <Input
                      label='Email'
                      value={email}
                      onChange={(value) => {
                        handleChange("email");
                        setEmail(value);
                      }}
                      required
                      error={errors.email}
                    />
                  </div>
                  <div className='grid-item'>
                    <PhoneInput
                      label='Phone'
                      value={phoneNumber}
                      onChange={(value: number) => {
                        handleChange("phoneNumber");
                        setPhoneNumber(value.toString());
                      }}
                      required
                      error={errors.phoneNumber}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='pd-cont'>
              <div className='pd-header'>Address</div>
              <div className='pd-form-cont'>
                <div className='pd-form'>
                  <div className='grid-item'>
                    <Input
                      label='Address Line 1'
                      value={address1}
                      onChange={(value) => {
                        handleChange("address1");
                        setAddress1(value);
                      }}
                      required
                      error={errors.address1}
                    />
                  </div>
                </div>
                <div className='pd-form'>
                  <div className='grid-item'>
                    <Input
                      label='Address Line 2'
                      value={address2}
                      onChange={(value) => setAddress2(value)}
                      error=''
                    />
                  </div>
                </div>
                <div className='pd-form-grid-3'>
                  <div className='grid-item'>
                    <Input
                      label='City'
                      value={city}
                      onChange={(value) => {
                        handleChange("city");
                        setCity(value);
                      }}
                      required
                      error={errors.city}
                    />
                  </div>
                  <div className='grid-item'>
                    <Input
                      label='Country/States'
                      value={state}
                      onChange={(value) => {
                        handleChange("state");
                        setState(value);
                      }}
                      required
                      error={errors.state}
                    />
                  </div>
                </div>{" "}
                <div className='pd-form-grid-2'>
                  <div className='grid-item'>
                    <CountryPicker
                      label='Country '
                      value={countryCode}
                      onChange={(value) => setCountryCode(value)}
                      required
                      onCodeChange={(value) => setCountry(value)}
                    />
                  </div>
                  <div className='grid-item'>
                    <Input
                      label='Postal/Zip Code'
                      value={postal}
                      onChange={(value) => {
                        handleChange("postal");
                        setPostal(value);
                      }}
                      required
                      error={errors.postal}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='pd-cont'>
              <div className='tc-cont'>
                <div className='tick-cont'>
                  <div
                    className='tc-check'
                    onClick={() => setPromoCheck(!promoCheck)}
                  >
                    {promoCheck && (
                      <div className='tc-checked'>
                        <img alt='' src={check} className='tc-check-ic' />
                      </div>
                    )}
                  </div>
                  Agree to receive marketing emails and or update about
                  promotions
                </div>
                <div className='tick-cont'>
                  <div
                    className='tc-check'
                    onClick={() => setRulesCheck(!rulesCheck)}
                  >
                    {rulesCheck && (
                      <div className='tc-checked'>
                        <img alt='' src={check} className='tc-check-ic' />
                      </div>
                    )}
                  </div>
                  <div>
                    Agree to privacy policy and{" "}
                    <span
                      className='tc-link'
                      onClick={() => {
                        setIsModalOpen(true);
                      }}
                    >
                      terms and conditions
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className='pd-btn-cont'>
              <Button
                text='Back'
                isPrimary={false}
                onClick={() => {
                  handleClearForm();
                  navigate("/");
                }}
                isBorder
              />
              <Button
                text='Register'
                isPrimary
                onClick={async () => {
                  if (rulesCheck && !isLoading) {
                    let valid = await validateForm();
                    if (valid) {
                      handleRegister();
                    }
                  }
                }}
                isDisable={!rulesCheck}
                isLoading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <TcModal
          onClose={() => {
            setIsModalOpen(false);
          }}
          onAgree={() => {
            setRulesCheck(true);
            setIsModalOpen(false);
          }}
          data={policyData}
        />
      )}
    </div>
  );
};

export default Register;
